import type { AssetDTO } from './asset';
import { isGroupedByEvent, type SearchParameters } from './searchParameters';

// A gallery tile leads to its asset's event, not the asset, when the search is
// grouped by event. Grouped searches request each asset's primary event, but a
// tile without one still falls back to the asset.
export const shouldLinkToEvent = <A extends Pick<AssetDTO, 'eventId'>>(
  searchParameters: SearchParameters,
  asset: A
): asset is A & { eventId: string } =>
  isGroupedByEvent(searchParameters) && Boolean(asset.eventId);
